function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.0248 12C11.6248 12 14.4248 8.9 15.6248 7.1C16.1248 6.4 16.1248 5.5 15.6248 4.8C14.4248 3.1 11.6248 0 8.0248 0C4.4248 0 1.6248 3.1 0.424805 4.9C-0.0751953 5.6 -0.0751953 6.5 0.424805 7.1C1.6248 8.9 4.4248 12 8.0248 12ZM8.0248 3C9.7248 3 11.0248 4.3 11.0248 6C11.0248 7.7 9.7248 9 8.0248 9C6.3248 9 5.0248 7.7 5.0248 6C5.0248 4.3 6.3248 3 8.0248 3Z",
  fill: "white"
});

const SvgPreview = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPreview, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/preview.a5afd774.svg";
export { ForwardRef as ReactComponent };